import EmployeeIndex from '@/views/employees/EmployeeIndex.vue';
import AddEmployee from '@/views/employees/AddEmployee.vue';
import EditEmployee from '@/views/employees/EditEmployee.vue';

export default [
  {
    path: '/employees',
    name: 'employees.index',
    component: EmployeeIndex,
    meta: {
      title: 'employees.indexTitle',
      requiresAuth: true,
      requiredPerm: 'employees.display',
    },
    children: [
      {
        path: '/employees/create',
        name: 'employees.create',
        component: AddEmployee,
        meta: {
          title: 'employees.addTitle',
          requiresAuth: true,
          requiredPerm: 'employees.create',
        }
      },
      {
        path: '/employees/:id/edit',
        name: 'employees.edit',
        component: EditEmployee,
        props: true,
        meta: {
          title: 'employees.editTitle',
          requiresAuth: true,
          requiredPerm: 'employees.update',
        }
      }
    ]
  },
];
